import config from './firebase.config'

import { initializeApp } from "firebase/app";

const fbApp = initializeApp(config);

export {
	fbApp
}
